import { render, staticRenderFns } from "./HomeDirectorWelcome.vue?vue&type=template&id=2e2dd62d"
import script from "./HomeDirectorWelcome.vue?vue&type=script&lang=js"
export * from "./HomeDirectorWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports